import React from 'react';
import { FirmAdminListProps } from './FirmAdminInterface/FirmAdminInterface';
import List from 'components/List/List';

import './_FirmAdminList.scss';
import { Row } from 'components/List/types';
import { AdminViewModel } from 'store/admins/types';
import { admins } from 'routes/routePaths';

const FirmAdminList: React.FC<FirmAdminListProps> = ({ firmAdmins, updateStatus, onAddNewItem }) => {
  const handleAction = (firmAdmin: AdminViewModel) => {
    updateStatus(firmAdmin, !firmAdmin.isVerified);
  };

  const prepareRows = (items: AdminViewModel[]): Row[] => {
    return items.map((firmAdmin) => {
      return {
        data: [
          { label: firmAdmin.name, link: { href: `${admins.list}/${firmAdmin.id}` } },
          { label: firmAdmin.email },
          { label: firmAdmin.fcaNumber },
          { label: firmAdmin.role },
          { label: firmAdmin.company },
          { label: firmAdmin.location },
          { label: firmAdmin.activeLabel },
          {
            label: firmAdmin.buttonActivationLabel,
            action: () => firmAdmin,
          },
        ],
        key: firmAdmin.id,
      };
    });
  };

  return (
    <>
      <List
        listName="Managers"
        labels={['Name', 'Email', 'FCA Number', 'Permissions', 'Company', 'Location', 'Verified', '']}
        rows={prepareRows(firmAdmins)}
        onAction={handleAction}
        addNewLabel="Add Manager"
        onAddNewItem={onAddNewItem}
      />
    </>
  );
};

export default FirmAdminList;
